import { render, staticRenderFns } from "./SchoolCreate.vue?vue&type=template&id=5d31663b&scoped=true&"
import script from "./SchoolCreate.vue?vue&type=script&lang=js&"
export * from "./SchoolCreate.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCreate.vue?vue&type=style&index=0&id=5d31663b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31663b",
  null
  
)

export default component.exports